import { Button, InputField } from '@salt/components';
import React, { useCallback, useState } from 'react';
import { updateProject } from '../../api/users';
import ColourPicker from './create/ColourPicker';

const EditProjectModal = ({ handleEditProjectModalClose, project, fetchData }) => {
  const [newName, setNewName] = useState(project.name);
  const [newColour, setNewColour] = useState(project.accent_colour);

  const onMove = useCallback(() => {
    updateProject({
      projectId: project.id,
      name: newName.replace(/'/g, '%27').replace(/"/g, '%22'),
      accentColour: newColour,
    })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to move user project');
      });
    handleEditProjectModalClose();
  }, [newName, newColour, project]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleEditProjectModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <h2 className="w-full mb-2 font-[18px] text-center">Edit Project Name and Colour</h2>
          <div>
            <span className="text-base">Change Project name</span>
            <div className="w-full mt-4">
              <InputField
                onChange={(event) => setNewName(event.target.value)}
                value={newName}
                labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
                backgroundClass="bg-secondary-light"
              />
            </div>
            <ColourPicker
              newColour={newColour}
              setNewColour={setNewColour}
              description="Choose a colour to identify your Project."
            />
          </div>

          <div>
            <br />
            <Button
              onClick={handleEditProjectModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={onMove}
              disabled={
                (newName === project.name && newColour === project.accent_colour) ||
                newName.trim().length === 0
              }
              type="positive"
              className="max-w-[146px] h-[36px] ml-auto float-right"
              paddingClassName="px-6"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProjectModal;
